import { createFileRoute } from "@tanstack/react-router";

import FriendStatisticsPage from "~/pages/friends/FriendStatisticsPage.tsx";

export const Route = createFileRoute("/_auth/friends/$playerId/statistics")({
    component: FriendStatisticsPage,
});
